import React from 'react'
import { compose, toClass, withProps } from 'recompose'
import { getPrimaryAddress } from 'sidecar-utility-library'

const enhance = compose(
  BaseComponent =>
    ({ children, ...otherProps }) => (
      <BaseComponent {...otherProps}>{children}</BaseComponent>
    ),
  toClass,
  withProps(props => {
    let { addresses = [], address } = props

    // when this list item is used in a map info overlay, the props
    // will already have an address (it's how the marker got placed).
    // If we're not in a map, we want to set the address to the primary.
    // If we always used the primary, then the list item in the overlay
    // could be showing a different address than where the pin is located.
    if (!address) {
      address = getPrimaryAddress(addresses)
    }

    return { address }
  }),
)

export default enhance
